import { IAppState } from '../../../AppModulesWrapper';

export const selectIsMultiPostingAvailable = (state: IAppState) => {
  const { publishTerms } = state.servicePickerWidget;

  return publishTerms.isMultipostingAvailable;
};
